export default __webpack_public_path__ + "static/media/closebtn.e90f997e.svg";